/**
 * This function servers as a replacement for process.env.KEY as the proocess.env.KEY syntax
 * is converted into string value on next build, which is not aligned with current build
 * process where we're building once and deploying everywhere.
 *
 * @param key environment variable whose value needs to be found
 * @returns
 */
const getEnv = function (key) {
  return process.env[key] || '';
};

module.exports = getEnv;
